module.exports = __webpack_public_path__ + "4b9e72fd626540e5e2b7c3913b104327.svg";